import React, {
  useEffect,
  useCallback,
  useState,
  useRef,
  useMemo,
} from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty, isNull } from 'lodash';
import moment from 'moment';
import { Listings } from 'containers/AppContainer/typings';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import {
  LISTINGS,
  PROCEDURE_STATUSES,
  PROCEDURE_STEPS,
  REJECTION_REASON,
} from 'containers/data-structure';

import JudgementAddComplement from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/JudgementAddComplement';
import ExpertisesRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/ExpertisesRecap';
import DocumentRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/DocumentRecap';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import {
  activateDecisionButton,
  validateAfterRejection,
} from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/utils';
import { Grid } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/AppealAdd/Recap/messages';
import {
  DIALOGS,
  DIALOGS_STATE,
} from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import { IOpenState } from 'containers/CourtManagerLegalProceedings/JudgementAdd/typings';
import { Container } from 'containers/LawyerLegalProceedingsPage/AppealAdd/Recap/styled-component';
import PronouncingValidationDialog from 'containers/LawyerLegalProceedingsPage/AppealAdd/Recap/Dialogs/PronouncingValidationDialog';
import PronouncingRejectionDialog from 'containers/LawyerLegalProceedingsPage/AppealAdd/Recap/Dialogs/PronouncingRejectionDialog';
import JudgementAddDocumentDecisionRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/JudgementAddDocumentDecisionRecap';
import JudgementAddDecisionRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/JudgementAddDecisionRecap';
import { toBeEdited } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import { toast } from 'react-toastify';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import FirmReferenceForm from 'components/FirmReferenceForm';

import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import {
  STATUS_PENDING,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';
import JudgementAddUpdateRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/UpdateStepRecap';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import {
  formatCourtFileNumber,
  getPendingFeeNotesByStep,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { isBlockStatusClaim } from 'containers/CourtManagerLegalProceedings/utils';
import { useSelector } from 'react-redux';
import { makeSelectFeeNotes } from 'containers/LawyerFeeNote/selectors';

export interface JudgementAddPronouncingRecapProps {
  intl: IntlShape;
  listings: Listings;
  judgementAddDocument: JudgementADDDocumentType;
  isManager: boolean;
  judgementAdd?: any;
  claimNumber?: string;
  requestMakeJudgementAddDocumentDecision?: Function;
  setJudgementAdd?: Function;
  requestUpdateJudgementAddDocument?: Function;
  judiciaryProcessId?: number;
  setDialogOpenFirmReference?: Function;
  requestGetJudgementAdd?: Function;
  judgementAddDocumentIds?: any[];
  expertReport?: ExpertReportType;
  judgementOnMerits?: JudgementOnMeritsType;
  handleCivilPartyDialog?: Function;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  feeNotes: any;
  claimAssignment: any;
  setOpenFeeNoteDialog: Function;
  isConsultation: Boolean;
  policyInfo: any;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestGetDocByDocumentumId: Function;
  setOpenInvoiceFeeNoteUpdateInfoDialog: Function;
  openInvoiceFeeNoteUpdateInfoDialog: boolean;
  setDocumentId: Function;
  handleValidateUpdateJudgementAddDocument: Function;
  setJudgemenAddDocumentToUpdate: Function;
}

const JudgementAddPronouncingRecap: React.FC<JudgementAddPronouncingRecapProps> = (
  props,
): JSX.Element => {
  const { judgementAddDocument } = props;
  const [isDialogOpen, setIsDialogOpen] = useState<IOpenState>({
    ...DIALOGS_STATE,
  });
  const [dropDown, setDropDown] = useState<null | HTMLElement>(null);
  const handleIsDialogOpen = (
    dialog: string,
    value?: boolean,
    toUpdate: boolean = false,
  ) => () => {
    setIsDialogOpen({ ...isDialogOpen, [dialog]: !!value, toUpdate });
  };

  const expertises = useMemo(() => {
    return get(judgementAddDocument, 'expertises', []).filter(
      (el: any) => !isEmpty(el.victims) || !isEmpty(el.vehicules),
    );
  }, [judgementAddDocument]);
  useEffect(() => {});
  const feeNotesStore = useSelector(makeSelectFeeNotes());

  const dropDownMenuElements = useCallback(() => {
    const pronouncingDecision = [
      {
        title: translate(messages.courtManagerJudgementValidate, props),
        action: handleIsDialogOpen(DIALOGS.VALIDATION, true),
      },
      {
        title: translate(messages.courtManagerJudgementRefuse, props),
        action: handleIsDialogOpen(DIALOGS.REFUSAL, true),
      },
    ];
    const updatePronouncing = {
      title: translate(messages.courtManagerJudgementUpdate, props),
      action: handleIsDialogOpen(DIALOGS.VALIDATION, true, true),
    };
    return [
      get(props.judgementAddDocument, 'status') === STATUS_PENDING ||
      validateAfterRejection(props.judgementAddDocument)
        ? [
            ...pronouncingDecision,
            featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
            get(props.judgementAddDocument, 'status') !== STATUS_PENDING &&
            get(props.judgementAdd, 'status') !== STATUS_PENDING
              ? updatePronouncing
              : null,
          ]
        : featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
          get(props.judgementAddDocument, 'status') !== STATUS_PENDING &&
          get(props.judgementAdd, 'status') !== STATUS_PENDING
        ? updatePronouncing
        : null,
    ]
      .flat()
      .filter(item => !isNull(item)) as any;
  }, [get(props.judgementAddDocument, 'status')]);

  const feeNotes = useMemo(
    () =>
      getPendingFeeNotesByStep(
        feeNotesStore,
        PROCEDURE_STEPS.ARRET_ADD,
        null as any,
        !isEmpty(props.judgementAddDocument)
          ? [get(props.judgementAddDocument, 'id')]
          : [],
        currentIntervenantStorage?.get()?.sagis_code,
      ),
    [],
  );

  const handleValidateUpdate = () => {
    if (
      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
      !isEmpty(feeNotes) &&
      !props.isManager
    ) {
      props.setJudgemenAddDocumentToUpdate(judgementAddDocument);
      return props.setOpenInvoiceFeeNoteUpdateInfoDialog(true);
    } else {
      props.setJudgemenAddDocumentToUpdate(judgementAddDocument);
      return props.handleValidateUpdateJudgementAddDocument(
        judgementAddDocument,
      );
    }
  };

  const isCreator = useMemo(
    () =>
      props.isManager
        ? true
        : isNull(get(props.judgementAddDocument, 'uploadedBy'))
        ? get(props.judgementAdd, 'creator', '')
        : get(props.judgementAddDocument, 'uploadedBy') ==
          currentIntervenantStorage.get()?.preferred_username,
    [
      props.isManager,
      get(props.judgementAddDocument, 'uploadedBy'),
      get(props.judgementAdd, 'creator', ''),
    ],
  );

  const lawyerAssignment =
    props.claimAssignment.find(
      (el: any) =>
        el.assignedLawyer === currentIntervenantStorage.get()?.sagis_code &&
        el.judiciaryProcessId === props.judiciaryProcessId &&
        el.isDeleted === false,
    ) || {};

  const feeNoteAssignment = get(props, 'feeNotes', [])
    .sort(
      (a: any, b: any) =>
        new Date(get(a, 'createdAt')).getTime() -
        new Date(get(b, 'createdAt')).getTime(),
    )
    .find((el: any) =>
      el.judgementAddDocumentId
        ? el.judgementAddDocumentId === get(props.judgementAddDocument, 'id') &&
          el.codeIntervenant === currentIntervenantStorage.get()?.sagis_code
        : el.step === PROCEDURE_STEPS.ARRET_ADD &&
          new Date(el.createdAt).getTime() >=
            new Date(
              get(props.judgementAddDocument, 'createdAt', ''),
            ).getTime(),
    );
  const lawyerAssignmentDate = get(
    lawyerAssignment,
    'lawyerAssignmentDate',
    get(lawyerAssignment, 'createdAt', null),
  );

  const lawyerFirmReference = get(lawyerAssignment, 'firmReference', null);

  const feeNoteToGenerate = {
    step: PROCEDURE_STEPS.ARRET_ADD,
    codeIntervenant:
      currentIntervenantStorage.get() &&
      currentIntervenantStorage.get().sagis_code,
    judgementDate: get(props.judgementAddDocument, 'judgementDate', null),
    judgementAddDocumentId: get(props.judgementAddDocument, 'id', null),
    judgementId:
      get(props.judgementAddDocument, 'status') === ''
        ? get(props.judgementAdd, 'id')
        : undefined,
    firmReference: lawyerFirmReference,
    status:
      get(props.judgementAddDocument, 'status') === ''
        ? get(props.judgementAdd, 'status') === PROCEDURE_STATUSES.TO_EDIT
          ? PROCEDURE_STATUSES.REJECTED
          : PROCEDURE_STATUSES.PENDING
        : get(props.judgementAddDocument, 'status') ===
          PROCEDURE_STATUSES.REJECTED
        ? PROCEDURE_STATUSES.REJECTED
        : PROCEDURE_STATUSES.PENDING,
    comment:
      get(props.judgementAddDocument, 'status') === ''
        ? get(props.judgementAdd, 'status') === PROCEDURE_STATUSES.TO_EDIT
          ? REJECTION_REASON
          : null
        : get(props.judgementAddDocument, 'status') ===
          PROCEDURE_STATUSES.REJECTED
        ? REJECTION_REASON
        : null,
    claimNumber: props.claimNumber,
    courtNumber: formatCourtFileNumber(
      get(props.judgementAdd, 'judgementAdd.courtFile'),
    ),
  };

  return (
    <Container>
      {!props.isManager &&
        !props.isConsultation &&
        !isBlockStatusClaim(props.policyInfo) &&
        lawyerAssignment &&
        get(props.judgementAddDocument, 'id') && (
          <FirmReferenceForm
            firmReference={
              feeNoteAssignment
                ? get(feeNoteAssignment, 'firmReference')
                : lawyerFirmReference
            }
            formInputLabel={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            formInputName={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            validationButtonTitle={translate(messages.generateFeeNote, props)}
            setIsDialogOpenFirmReference={props.setDialogOpenFirmReference}
            isFeeNoteGenerated={feeNoteAssignment}
            isPronoucing
            feeNote={feeNoteToGenerate}
            isAssignmentDateValid={
              new Date(lawyerAssignmentDate).getTime() <=
              new Date(
                get(props.judgementAddDocument, 'createdAt', ''),
              ).getTime()
            }
            judiciaryProcessId={props.judiciaryProcessId}
            assignment={lawyerAssignment}
            lawyerFirmReference={lawyerFirmReference}
          />
        )}
      <JudgementAddComplement
        judgementAddDocuments={judgementAddDocument}
        listings={props.listings}
        isManager={props.isManager}
      />
      <ExpertisesRecap
        expertises={expertises}
        expertiseList={get(props.listings, LISTINGS.EXPERTISE, [])}
        sagisVictimInfo={props.sagisVictimInfo}
        sagisOpposingParties={props.sagisOpposingParties}
      />
      <Grid container direction="row">
        <Grid item xs={6}>
          <DocumentRecap
            judgementAddDocuments={props.judgementAddDocument}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        </Grid>
        {activateDecisionButton(props.judgementAddDocument, props.isManager) &&
        get(props.judgementAddDocument, 'status') !==
          PROCEDURE_STATUSES.VALIDATED ? (
          <Grid item xs={6} className="judgement-decision">
            <DropDownDecisionMenu
              setDropDown={setDropDown}
              dropDown={dropDown}
              label={translate(messages.managerDecision, props)}
              menuElements={dropDownMenuElements()}
            />
          </Grid>
        ) : (
          featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
          props.isManager &&
          get(props.judgementAddDocument, 'status') !== STATUS_PENDING &&
          get(props.judgementAdd, 'status') !== STATUS_PENDING && (
            <Grid item xs={6} className="judgement-update">
              <PrimaryButton
                title={translate(messages.courtManagerJudgementUpdate, props)}
                onClick={
                  get(props.judgementAddDocument, 'status') === STATUS_VALIDATED
                    ? handleIsDialogOpen(DIALOGS.VALIDATION, true, true)
                    : props.handleCivilPartyDialog &&
                      props.handleCivilPartyDialog(
                        DIALOGS.VALIDATION,
                        true,
                        true,
                        false,
                      )
                }
                background={BUTTON_COLORS.PRIMARY_BLUE}
                border={BUTTON_COLORS.PRIMARY_BLUE}
                titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                className="button"
              />
            </Grid>
          )
        )}
        <Grid container direction="column">
          <Grid item xs={6}>
            <JudgementAddDocumentDecisionRecap
              judgementAddDocument={props.judgementAddDocument}
            />
            <JudgementAddDecisionRecap
              judgementAdd={props.judgementAdd}
              judgementAddDocument={props.judgementAddDocument}
            />
            <JudgementAddUpdateRecap
              updatedBy={get(props, 'judgementAddDocument.updatedBy', '')}
            />
          </Grid>

          {toBeEdited(props.judgementAddDocument, props.isManager) &&
            isCreator &&
            !userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMONITORINGMANAGER,
            ) && (
              <Grid item xs={6} className="button">
                <PrimaryButton
                  className="button"
                  title={translate(messages.validate, props)}
                  data-testId="validate"
                  onClick={handleValidateUpdate}
                  background={BUTTON_COLORS.PRIMARY_BLUE}
                  border={BUTTON_COLORS.PRIMARY_BLUE}
                  titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                />
              </Grid>
            )}
        </Grid>
      </Grid>
      <PronouncingValidationDialog
        judgementAddDocument={props.judgementAddDocument}
        open={isDialogOpen[DIALOGS.VALIDATION]}
        handleClose={handleIsDialogOpen(DIALOGS.VALIDATION)}
        lawyer={get(props.judgementAdd, 'creator', '')}
        claimId={get(props.judgementAdd, 'claimId', '')}
        judgementAdd={props.judgementAdd}
        requestMakeJudgementAddDocumentDecision={
          props.requestMakeJudgementAddDocumentDecision
        }
        setJudgementAdd={props.setJudgementAdd}
        claimNumber={props.claimNumber}
        requestGetJudgementAdd={props.requestGetJudgementAdd}
        expertReport={props.expertReport}
        judgementOnMerits={props.judgementOnMerits}
        toUpdate={get(isDialogOpen, 'toUpdate', false)}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
      />
      <PronouncingRejectionDialog
        isRefuseDialogOpen={isDialogOpen[DIALOGS.REFUSAL]}
        handleCancel={handleIsDialogOpen(DIALOGS.REFUSAL)}
        requestMakeJudgementAddDocumentDecision={
          props.requestMakeJudgementAddDocumentDecision
        }
        claimId={get(props.judgementAdd, 'claimId', '')}
        lawyer={get(props.judgementAdd, 'creator', '')}
        judgementAdd={props.judgementAdd}
        judgementAddDocument={props.judgementAddDocument}
        claimNumber={props.claimNumber}
        setJudgementAdd={props.setJudgementAdd}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
      />
    </Container>
  );
};

export default injectIntl(JudgementAddPronouncingRecap);
